import { render, staticRenderFns } from "./EmptyImg.vue?vue&type=template&id=617776c2&scoped=true&"
import script from "./EmptyImg.vue?vue&type=script&lang=js&"
export * from "./EmptyImg.vue?vue&type=script&lang=js&"
import style0 from "./EmptyImg.vue?vue&type=style&index=0&id=617776c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617776c2",
  null
  
)

export default component.exports